import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead: React.FC = () => {
  return (
    <Helmet>
      {/* Basic meta tags */}
      <html lang="es" />
      <title>Street Vape - Tu Nueva Tienda de Vapeo | Próximamente</title>
      <meta name="description" content="Prepárate para Street Vape, tu nuevo destino online para los mejores vapeadores, e-líquidos premium y accesorios de vapeo. ¡Lanzamiento oficial muy pronto! Mantente atento." />
      <meta name="keywords" content="street vape, vapeo, vapeadores, e-liquidos, tienda de vapeo, próximamente, vape shop" />
      
      {/* Open Graph Tags */}
      <meta property="og:title" content="Street Vape - Próximamente | Novedades en Vapeo" />
      <meta property="og:description" content="¡Street Vape está llegando! Descubre pronto nuestra selección de vapeadores, e-líquidos y accesorios." />
      <meta property="og:image" content="https://streetvape.es/assets/logo-streetvape.jpg" />
      <meta property="og:url" content="https://streetvape.es" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Street Vape" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Street Vape - Próximamente | Novedades en Vapeo" />
      <meta name="twitter:description" content="¡Street Vape está llegando! Descubre pronto nuestra selección de vapeadores, e-líquidos y accesorios." />
      <meta name="twitter:image" content="https://streetvape.es/assets/logo-streetvape.jpg" />
      
      {/* Favicon Links */}
      <link rel="icon" href="/favicon.ico" />
      <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
      <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
      <link rel="manifest" href="/site.webmanifest" />
      
      {/* Google Fonts moved to CSS reset file */}
      
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Street Vape",
            "url": "https://streetvape.es",
            "logo": "https://streetvape.es/assets/logo-streetvape.jpg",
            "description": "Próxima apertura de Street Vape, tu tienda especializada en vapeadores, e-líquidos y accesorios de alta calidad.",
            "potentialAction": {
              "@type": "ViewAction",
              "target": "https://streetvape.es"
            }
          }
        `}
      </script>
    </Helmet>
  );
};

export default SEOHead;